import React from "react";
import PropTypes from "prop-types";
import { getPairMeta } from "@components/pages/Futures/components/Quotes/pairMeta";
import { normalizeOrderSymbol } from "@helpers/formatOrders";
import TradeArrowUpIcon from "@assets/icons/TradeArrowUpIcon";
import TradeArrowDownIcon from "@assets/icons/TradeArrowDownIcon";

export const TradeCell = ({
  symbol,
  side,
  isLong,
  onPairClick,
  iconSize = 20,
  longColor = "#21B45F",
  shortColor = "#FF2828",
}) => {
  const normalized = normalizeOrderSymbol(symbol);
  const baseAsset = normalized
    ? normalized.replace(/(USDT|USDC|BUSD)$/i, "")
    : "";
  const meta = getPairMeta(normalized || `${baseAsset}USDT`);

  const long =
    typeof isLong === "boolean"
      ? isLong
      : typeof side === "string"
        ? !["sell", "short"].includes(side.toLowerCase())
        : !side;

  return (
    <div className="futures-orders-trade-cell">
      <span className="futures-orders-trade-cell__direction">
        {long ? (
          <TradeArrowUpIcon size={iconSize} color={longColor} />
        ) : (
          <TradeArrowDownIcon size={iconSize} color={shortColor} />
        )}
      </span>

      <span className="futures-orders-trade-cell__icon-wrapper">
        {meta?.icon ? (
          <img
            src={meta.icon}
            alt={baseAsset || "coin"}
            className="futures-orders-trade-cell__icon"
          />
        ) : null}
      </span>

      {onPairClick ? (
        <button
          type="button"
          onClick={() => onPairClick(symbol)}
          className="futures-orders-trade-cell__name futures-orders-trade-cell__name--button"
        >
          {baseAsset || symbol}
        </button>
      ) : (
        <span className="futures-orders-trade-cell__name">
          {baseAsset || symbol}
        </span>
      )}
    </div>
  );
};

TradeCell.propTypes = {
  symbol: PropTypes.string,
  side: PropTypes.string,
  isLong: PropTypes.bool,
  onPairClick: PropTypes.func,
  iconSize: PropTypes.number,
  longColor: PropTypes.string,
  shortColor: PropTypes.string,
};

export default TradeCell;
